<template>
  <div class="errPage-container">
    <el-button icon="el-icon-arrow-left" class="pan-back-btn" @click="back">{{ $t('errorPage.errorInfo.back') }}</el-button>
    <el-row>
      <el-col :span="12">
        <h1 class="text-jumbo text-ginormous">Oops!</h1>
        <h2>{{ $t('errorPage.errorInfo.security') }}</h2>
        <h6>{{ $t('errorPage.errorInfo.Maxerrors') }}</h6>
        <ul class="list-unstyled">
          <li>{{ $t('errorPage.errorInfo.MaxerrorsRules') }}:</li>
          <li class="link-type">
            <router-link to="/dashboard"> {{ $t('errorPage.errorInfo.Maxrecent') }} </router-link>
          </li>
          <li class="link-type">
            <a href="https://www.taobao.com/">{{ $t('errorPage.errorInfo.errorscode') }}</a>
          </li>
          <li><a href="#" @click.prevent="dialogVisible = true">{{ $t('errorPage.errorInfo.verification') }}</a></li>
        </ul>
      </el-col>
      <el-col :span="12">
        <img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream." />
      </el-col>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      :title="$t('errorPage.errorInfo.errorscode')"
    >
      <img :src="ewizardClap" class="pan-img" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Page401',
  data() {
    const errGif = this.$getPublicImage('401/401.gif') + '?' + +new Date();
    return {
      errGif: errGif,
      ewizardClap: 'https://wpimg.wallstcn.com/007ef517-bafd-4066-aae4-6883632d9646',
      dialogVisible: false,
    };
  },
  methods: {
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: '/dashboard' });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.errPage-container {
  width: 800px;
  max-width: 100%;
  margin: 100px auto;
  .pan-back-btn {
    background: #008489;
    color: #fff;
    border: none !important;
  }
  .pan-gif {
    margin: 0 auto;
    display: block;
  }
  .pan-img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  .text-jumbo {
    font-size: 60px;
    font-weight: 700;
    color: #484848;
  }
  .list-unstyled {
    font-size: 14px;
    li {
      padding-bottom: 5px;
    }
    a {
      color: #008489;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
